import type { QueryFunctionContext } from '@tanstack/react-query';
import { gqlClient } from '@/utilities/graphQLClient';
import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';

const QUERY = gql(`
  query getAggregatePortfolioPerformanceTimeseries(
    $startTimestamp: Float!
    $endTimestamp: Float!
  ) {
    AggregatePortfolio {
      performance(
        startTimestamp: $startTimestamp
        endTimestamp: $endTimestamp
      )
    }
  }
`);

type Args = VariablesOf<typeof QUERY>;

// TODO: This is pretty much casting to a Record<string, number> :(...
// At least the return type is inline with the legacy response type
// We need a better way to either check the type or, ideally, have the query return the correct type
const isRecord = (value: unknown): value is Record<string, number> => {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
};

export const queryFn = async ({
  queryKey: [_key, _type, { startTimestamp, endTimestamp }],
}: QueryFunctionContext<[string, string, Args]>): Promise<
  Record<string, number>
> => {
  const {
    AggregatePortfolio: { performance },
    errors,
  } = await gqlClient.request(
    gql(`
      query getAggregatePortfolioPerformanceTimeseries(
        $startTimestamp: Float!
        $endTimestamp: Float!
      ) {
        AggregatePortfolio {
          performance(
            startTimestamp: $startTimestamp
            endTimestamp: $endTimestamp
          )
        }
      }
    `),
    { startTimestamp, endTimestamp }
  );

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return isRecord(performance) ? performance : {};
};
